import _ from 'lodash'
import {Atributos, Model} from './model.module.js'

export default class RelatorioPrevencao extends Model {
	atributos = {
		id: new Atributos(0, {required: true}),
		local: new Atributos('', {required: true}),
		data: new Atributos('', {required: true}),
		id_aeronave: new Atributos('', {required: false}),
		id_estado: new Atributos('', {required: true}),
		id_cidade: new Atributos('', {required: true}),
		tipo_evento: new Atributos('', {required: true}),
		id_evento: new Atributos('', {required: true}),
		envolvidos: new Atributos('', {required: false}),
		descricao: new Atributos('', {required: true}),
		relator: new Atributos('', {required: false}),
		email: new Atributos('', {required: false}),
		telefone: new Atributos('', {required: false})
	}

	get(id) {
		this._axios('/Relatorio_prevencao/get_relatorio_prevencao/' + id, 'get', {
			callback: (retorno) => {
				if (retorno._request && retorno._status) {
					this.preencheAtributos(retorno.relatorio_prevencao)
				}
			}
		})
	}

	salvar(callback) {
		if (this.isValid()) {
			window.bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

			this._httpPost('/Relatorio_prevencao/salvar_prevencao', this.toModel(this.atributos), callback)
		} else {
			window.bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('menuEscala', 'menuEvermelho')})
		}
	}

	atualizar(callback) {
		if (this.isValid()) {
			window.bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
			const {id, id_evento, tipo_evento} = this.atributos
			const data = {id, id_evento, tipo_evento}
			this._httpPost('/Relatorio_prevencao/atualizar', this.toModel(data), callback)
		} else {
			window.bus.$emit('exibir-notificacao', {type: 'danger', text: this._traducao('menuEscala', 'menuEvermelho')})
		}
	}

	listar(callback) {
		this._httpGet('/Relatorio_prevencao/get_lista_relatorio_prevencao', callback)
	}

	excluir(id) {
		window.bus.$emit('load-in', {text: window._traducao('global', 'excluindo')})
		this._axios2('Relatorio_prevencao/excluir/' + id + '/', 'get', {
			callback(retorno) {
				if (retorno) {
					window.bus.$emit('exibir-notificacao', {
						text: window._traducao('global', 'excluidoComSucesso'),
						type: 'success'
					})
				} else {
					window.bus.$emit('exibir-notificacao', {type: 'danger', text: _traducao('global', 'naoFoiPossivelExcluir')})
				}
			},
			finally: () => window.bus.$emit('load-out')
		})
	}
}
